import React, { useEffect, useRef, useState } from 'react';
import './IndustriesSection.css';
import IndustryCard from './IndustryCard';

const industries = [
  { title: 'HEALTHTECH', description: 'By embracing digital transformation in your healthcare practice, you’re not only catering to the changing preferences of your existing patients but also positioning yourself to attract new ones.', route: "/portfolio/healthtech" },
  { title: 'PROPTECH', description: 'A transformative force shaping the future of property, construction, and real estate. By embracing these advancements, you can gain a competitive edge and unlock new opportunities in this dynamic market.', route: "/portfolio/proptech" },
  { title: 'RETAIL', description: 'Boost engagement and conversion by recommending tailored products and promotions across digital channels.', route: "/portfolio/retail" },
  { title: 'FINTECH', description: 'Craft tailored financial applications for digital transformation with us, including web and mobile trading platforms, retail banking, investment solutions, and stock exchange apps.', route: "/portfolio/fintech" },
  { title: 'LEGALTECH', description: 'Whether you are focused on contract management, legal research, or case management, our software solutions provide comprehensive tools to meet your specific needs.', route: "/portfolio/legaltech" },
  { title: 'MANUFACTURING', description: 'Take control of your production process like never before. With production planning software, you can schedule tasks seamlessly.', route: "/portfolio/manufacturing" },
];

const IndustriesSection = () => {
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);
  const previousScrollY = useRef(window.scrollY);
  const yOffsets = useRef(Array(industries.length).fill(0));
  const [animateSection, setAnimateSection] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setAnimateSection(true);
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  useEffect(() => {
    if (isMobile) return; // Disable scroll effect on mobile

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - previousScrollY.current;
      const direction = deltaY > 0 ? 'down' : 'up';

      cardRefs.current.forEach((ref, index) => {
        if (!ref) return;

        const isLeft = index % 3 === 0;
        const isRight = index % 3 === 2;

        if (isLeft || isRight) {
          const change = direction === 'down' ? -1.5 : 1.5;
          let newOffset = yOffsets.current[index] + change;
          newOffset = Math.max(-40, Math.min(40, newOffset));
          yOffsets.current[index] = newOffset;

          ref.style.transform = `translateY(${newOffset}px)`;
        }
      });

      previousScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobile]);

  return (
    <section
      className={`industries-section ${animateSection ? 'animate' : ''}`}
      ref={sectionRef}
    >
      <div className="container">
        <div className="industries-header">
          <h2>
            WE HELP <span className="blue-text">REIMAGINE <br /> INDUSTRIES</span>
          </h2>
          <p>
            We work across some of the most demanding industries, delivering robust web, software and mobile app solutions.
          </p>
        </div>

        <div className="industries-cards">
          {industries.map((item, index) => (
            <div
              key={index}
              ref={(el) => (cardRefs.current[index] = el)}
              className="industry-card-wrapper"
            >
              <IndustryCard title={item.title} description={item.description} route={item.route} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;